<template>

<!--    <div class="filter-sele-tag-wrap">-->
<!--        <div class="filter-tag">-->
<!--            All Strop-->
<!--        </div>-->
<!--    </div>-->

   <div v-if="dispFilterLs.length!=0" class="filter-sele-tag-wrap">
         
        <div v-for="(items,index) in dispFilterLs" :key="'dispFilterLs'+items+index" @click="toClearSelFilter(items)"  class="filter-tag">
         
         <div :key="'priceFilter'+index" v-if="items.min" >
           <span  v-c-tooltip.hover="{id:'priceFilter',  content:$t('cFilter.priceFilter')}">{{currencyCode+' '}}{{items.min+'-'+items.max}}</span>
         </div>
         <div :key="'durFilter'+index" v-else-if="items.from" >
           <span v-c-tooltip.hover="{id:'durFilter',content:$t('cFilter.durFilter'),}">{{items.from+'-'+items.to}}</span>
         </div>
         <div :key="'timeFilter'+index" v-else-if="items.start" >
           <span v-c-tooltip.hover="{id:'timeFilter',content:$t('cFilter.timeFilter'),}">{{items.start+'-'+items.end}}</span>
         </div>
         <div :key="'stopFilter'+index"  v-else-if="items.name.includes($t('flightResults.stop')) || items.name.includes($t('flightResults.stops') || items.name.includes($t('flightResults.nonstop')))" >
           <span v-c-tooltip.hover="{id:'stopFilter',content:$t('cFilter.stopFilter'),active:false}">{{items.name}}</span>
         </div>
         <div :key="'alFilter'+index" v-else >
          <span v-c-tooltip.hover="{id:'priceFilter',content:$t('cFilter.alFilter'),}"> {{items.name}}</span>
         </div>
         
              <!-- <div >
              
               {{items.min?items.min+'-'+items.max:items.from?
              items.from+'-'+items.to:items.name?items.name:items.start+'-'+items.end}} 

           </div>  -->
         
        </div>
        <span v-if="dispFilterLs.length>2" class="more active" @click="isToggleFilter">
            <span>{{$t('cFilter.more')}}</span>
            <span>{{$t('cFilter.less')}}</span>

        </span>
        

        </div> 
</template>
<script>
    import {COMPONENT_NAME, FILTER, PATHNAME} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
    import BaseConfiguration from "../../../../config/base";
export default {
    name: COMPONENT_NAME.C_FILTER_TAG,
    props: {
   dispFilterLs:{
       type:Array
   },
   currencyCode:{
      type: String
    }
  },
    data: () => ({
    toToggleFilter: false,
    
    }),

    
  methods:{
      isToggleFilter() {
          try {
              if (BaseConfiguration.isDebug) console.log("isToggleFilter");
              this.toToggleFilter=!this.toToggleFilter;
              this.$emit("toToggleFilter",this.toToggleFilter);

          } catch (err) {
              let body = Logger.buildRequest(
                  PATHNAME.FLIGHTRESULTS,
                  "error while modifing search",
                  err.toString(),
                  "isToggleFilter",
                  LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
          }
      },
 toClearSelFilter(pFilterItems) {
      try {
        // if(BaseConfiguration.isDebug) console.log("toClearSelFilter");
        if(this.dispFilterLs.length<=2) {
          this.toToggleFilter=false;
          this.$emit("toToggleFilter",this.toToggleFilter);
        }
    this.$emit('clearSelFilter',pFilterItems);
      } catch (err) {
              let body = Logger.buildRequest(
                FILE_NAME.FILTER,
                "error in toClearSelFilter",
                err.toString(),
                "toClearSelFilter",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        // return retValue;
      }, 


  
   },
 
}
</script>